var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0548 9.05477C19.0548 13.5821 15.7323 17.3428 11.3874 18V11.6836H13.5051L13.9067 9.05477H11.3874V7.37525C11.3874 6.64503 11.7525 5.95132 12.8844 5.95132H14.0162V3.72414C14.0162 3.72414 12.9939 3.54158 11.9716 3.54158C9.92698 3.54158 8.57607 4.81947 8.57607 7.08316V9.05477H6.27586V11.6836H8.57607V18C4.23124 17.3428 0.945236 13.5821 0.945236 9.05477C0.945236 4.05274 4.99797 0 10 0C15.002 0 19.0548 4.05274 19.0548 9.05477Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.07e88c607a21a1ccf767d8f9c29dcd02.svg";
export { ForwardRef as ReactComponent };